import { SkipContribution } from "@assets";
import { ActionItem } from "@components/ActionItem";
import { Overlay } from "@components/Overlay";
import { OverlayProps } from "@components/Overlay/types";
import { useModal } from "@hooks";
import { i18n, Translations } from "@i18n";
import { CancelContributionModal } from "./CancelContributionModal";
import { EditOneTimeContributionModalProps } from "./types";

export const EditOneTimeContributionModal = ({ item }: EditOneTimeContributionModalProps) => {
  const { show, dismiss } = useModal();

  const props: OverlayProps = {
    cta: {
      secondary: {
        title: i18n.t(Translations.EditRecurringContributionModalPrimaryCTA),
        onClick: dismiss,
      },
    },
  };

  return (
    <Overlay {...props}>
      <ActionItem
        leftIcon={<SkipContribution size={28} />}
        title={i18n.t(Translations.EditOneTimeContributionModalCancelTitle)}
        subtitle={i18n.t(Translations.EditOneTimeContributionModalCancelSubtitle)}
        onClick={() => show(<CancelContributionModal item={item} />)}
      />
    </Overlay>
  );
};
